export type NativePlatform = 'android' | 'ios' | null;

export function getNativePlatform(): NativePlatform {
  if (typeof window === 'undefined' || !window.ReactNativeWebView) {
    return null;
  }

  if ((window as Window & { nativePlatform?: string }).nativePlatform === 'android') {
    return 'android';
  }

  if ((window as Window & { nativePlatform?: string }).nativePlatform === 'ios') {
    return 'ios';
  }

  const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  if (/Android/i.test(userAgent)) {
    return 'android';
  }

  if (/iPhone|iPad|iPod/i.test(userAgent)) {
    return 'ios';
  }

  return null;
}

export function getNativePremiumStoreName(platform: NativePlatform): string {
  if (platform === 'android') {
    return 'Google Play';
  }

  if (platform === 'ios') {
    return 'Apple App Store';
  }

  return 'appbutiken';
}